import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  margin: 0 auto;
  padding: 16px;

  #search-container {
    margin-bottom: 16px;
  }

  #action-container {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 8px;

    button {
      width: 100%;
    }

    button:nth-child(1) {
      margin-right: 8px;
    }
  }

  @media screen and (min-width: 768px) {
    padding: 32px;

    #action-container {
      justify-content: flex-end;

      button {
        width: unset;
      }
    }
  }

  @media screen and (min-width: 1024px) {
  }
`;

export const ActionsColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  span {
    cursor: pointer;
    background-color: whitesmoke;
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 8px;
    width: 100%;
    max-width: 300px;
  }

  span:nth-child(4) {
    margin-bottom: 0;
  }
`;
